
import Vue from 'vue'
import { RD1Address, RD2Address, roundDuration } from '@/config'
import { authState, bet, getRoundTime, getRoundContractAddress, getBetsData, getUserBetsData, setUpSubscriptions, tearDownSubscriptions } from '@/wallet'
import { sleep, isMobile } from '@/utils'
import { explorer } from '@/connection'
import moment from 'moment'

export default Vue.extend({
  name: 'HomeView',
  mounted() {
    window.setInterval(() => {
      this.currentTime = Date.now()
    }, 100)
    this.updateAll()
  },
  data() {
    return {
      authTrigger: false,
      fishInputAmount1: 0,
      fishInputAmount2: 0,
      systemAlert: false,
      systemAlertMessage: '',
      betAlert: false,
      betAlertMessage: '',
      roundStart: '',
      roundEnd: '',
      roundStartTimestamp: 0,
      roundEndTimestamp: 0,
      roundContractAddress: '',
      totalAmountSide1: 0,
      totalAmountSide2: 0,
      userAmountSide1: 0,
      userAmountSide2: 0,
      userBox: false,
      RD1Address: '',
      RD2Address: '',
      betBtnDisabled: false,
      leftFishSize: '5em',
      rightFishSize: '5em',
      currentTime: Date.now(),
      progressMax: 100,
      progressValue: 0,
      roundState: '',
      explorer: '',
      prevTotalData: { side1: 0, side2: 0 },
      amountTooltipMsgLeft: '',
      amountTooltipMsgRight: '',
      showTooltipLeft: false,
      showTooltipRight: false,
      winState: false,
      countDown: 0,
      isMobile
    }
  },
  methods: {
    async _bet(side: 1 | 2) {
      if ((await authState()) == false) {
        this.systemAlert = true
        this.systemAlertMessage = 'Connect your wallet'
        await sleep(5000)
        this.systemAlert = false
        return
      }
      if (this.roundState == 'Finished') {
        this.systemAlert = true
        this.systemAlertMessage = 'This round is finished. The next round will be in one minute'
        await sleep(5000)
        this.systemAlert = false
        return
      }
      if (this.roundState == 'Prepearing...') {
        this.systemAlert = true
        this.systemAlertMessage = 'This round is prepearing now. The next round will be in one minute'
        await sleep(5000)
        this.systemAlert = false
        return
      }
      const amount = this[('fishInputAmount' + side) as keyof Vue]
      if (isNaN(amount) || amount < 1) {
        this.systemAlertMessage = 'Min bet 1 EVER'
        this.systemAlert = true
        await sleep(3000)
        this.systemAlert = false
        return
      }
      await bet(side, Number(amount) * 1e9)
    },
    async _copy(side: number) {
      if (side == 1) (this.$refs.leftAddr as HTMLInputElement).focus()
      if (side == 2) (this.$refs.rightAddr as HTMLInputElement).focus()
      document.execCommand('copy')
      await sleep(1000)
      const toolTipId = side == 1 ? 'copyBtnLeft' : 'copyBtnRight'
      this.$root.$emit('bv::hide::tooltip', toolTipId)
    },
    updateBetsData() {
      getRoundTime().then((time) => {
        this.roundStart = new Date(time.roundStart * 1000).toLocaleTimeString()
        this.roundEnd = new Date(time.roundEnd * 1000).toLocaleTimeString()
        getRoundContractAddress(time.roundStart, time.roundEnd).then((a) => {
          this.roundContractAddress = a.toString()
        })
      })
      getBetsData().then((data) => {
        this.totalAmountSide1 = data.side1
        this.totalAmountSide2 = data.side2
        //this.updateFishSize(data.side1, data.side2)
      })
      getUserBetsData().then((data) => {
        if (typeof data == 'undefined') return
        this.userAmountSide1 = data.side1
        this.userAmountSide2 = data.side2
        this.userBox = true
      })
    },
    updateRoundState() {
      if (this.currentTime < this.roundStartTimestamp + 60 * 1000) {
        this.roundState = 'Prepearing...'
        this.countDown = moment
          .unix(60 - (Date.now() - this.roundStartTimestamp) / 1000)
          .utc()
          .format('mm [:] ss')
      } else if (this.currentTime > this.roundStartTimestamp + 60 * 1000 && this.currentTime < this.roundEndTimestamp) {
        this.roundState = 'Running'
        this.countDown = moment
          .unix(roundDuration - (roundDuration * this.progressValue) / 100)
          .utc()
          .format('HH [:] mm [:] ss')
      } else if (this.currentTime > this.roundEndTimestamp) {
        this.roundState = 'Finished'
        if (this.userAmountSide1 > 0 && this.totalAmountSide1 > this.totalAmountSide2) this.winState = true
        if (this.userAmountSide2 > 0 && this.totalAmountSide2 > this.totalAmountSide1) this.winState = true
      }
    },
    updateAll() {
      getRoundTime().then((time) => {        
        this.roundStart = new Date(time.roundStart * 1000).toLocaleTimeString()
        this.roundEnd = new Date(time.roundEnd * 1000).toLocaleTimeString()
        this.roundStartTimestamp = time.roundStart * 1000
        this.roundEndTimestamp = time.roundEnd * 1000
        getRoundContractAddress(time.roundStart, time.roundEnd).then((a) => {
          this.roundContractAddress = a.toString()
        })
      })
      getBetsData().then((data) => {
        this.totalAmountSide1 = data.side1
        this.totalAmountSide2 = data.side2
        this.prevTotalData = { side1: data.side1, side2: data.side2 }
      })
      getUserBetsData().then((data) => {
        if (typeof data == 'undefined') {
          this.userBox = false
          return
        }
        this.userAmountSide1 = data.side1
        this.userAmountSide2 = data.side2
        this.userBox = true
      })
      this.RD1Address = RD1Address
      this.RD2Address = RD2Address
      this.systemAlert = false
      this.explorer = explorer()

      tearDownSubscriptions().then(() => {
        setUpSubscriptions()
      })
    },
  },
  watch: {
    async $roundTransactions() {
      if (this.roundState !== 'Running') return

      const currTotalData: { side1: number; side2: number } | undefined = await getUserBetsData()
      if (typeof currTotalData == 'undefined') return
      //if no changes exit
      if (currTotalData.side1 == this.prevTotalData.side1 && currTotalData.side2 == this.prevTotalData.side2) return

      let amount: number

      if (currTotalData.side1 > this.prevTotalData.side1) {
        amount = currTotalData.side1 - this.prevTotalData.side1
        this.amountTooltipMsgLeft = '+' + amount.toString()
        this.showTooltipLeft = true
        await sleep(5e3)
        this.showTooltipLeft = false
      } else if (currTotalData.side2 > this.prevTotalData.side2) {
        amount = currTotalData.side2 - this.prevTotalData.side2
        this.amountTooltipMsgRight = '+' + amount.toString()
        this.showTooltipRight = true
        await sleep(5e3)
        this.showTooltipRight = false
      } else {
        return
      }
      this.prevTotalData = currTotalData

      this.updateBetsData()
    },
    $permissionsChanged() {
      this.updateAll()
    },
    currentTime(_, currentTime) {
      if (this.roundEndTimestamp == 0) return
      //wait minute and update all
      if (currentTime > this.roundEndTimestamp) {
        if (currentTime > this.roundEndTimestamp + 60 * 1000) {
          this.updateAll()
        }
        this.progressValue = 100

        this.updateRoundState()
        return
      }
      this.updateRoundState()
      this.progressValue = 100 - ((this.roundEndTimestamp - currentTime) / 1000 / (roundDuration - 60)) * 100 // todo change interval value
    },
  },
})
